'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContainer = function ContentContainer(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-content-container' },
    children
  );
};

ContentContainer.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ContentContainer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ContentContainer/ContentContainer.js
// module id = 566
// module chunks = 11